export default "__VITE_ASSET__$GyhcxSI__"